/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import TemplateModel from 'cio/models/template';
import { task } from 'ember-concurrency';
import { tracked } from '@glimmer/tracking';
import InAppMessage from 'cio/app-models/in-app/in-app-message';
import ApiErrorsService from 'cio/services/api-errors';
import InAppMessageTemplateService from 'cio/services/in-app-message-template';
import { isVisualEditorInAppMessage } from 'cio/utils/in-app/message-config';

interface InAppArgs {
  template: TemplateModel;
}

export default class InApp extends Component<InAppArgs> {
  @service apiErrors!: ApiErrorsService;
  @service inAppMessageTemplate!: InAppMessageTemplateService;

  @tracked title = '';

  loadMessageTitle = task({ restartable: true }, async () => {
    let { template } = this.args;

    if (isVisualEditorInAppMessage(template)) {
      return;
    }

    try {
      let message = InAppMessage.deserialize(template.bodyJson);
      let messageTemplate = await this.inAppMessageTemplate.findMessageTemplate(message.messageId);
      this.title = messageTemplate?.name ?? 'Deleted template';
    } catch (e) {
      this.apiErrors.report(e);
    }
  });
}
